<template>
  <div>
    <table class="table table-sm table-hover" v-if="users">
      <tbody>
      <template v-for="(div, index) in getSortedDivision()">
        <tr class="division_info">
          <td colspan="10">
            <div class="flex justify-content-between">
              <div>
                <span>{{ div.title }}</span>&nbsp;
                <span v-for="(city, index) in (div.cities ?? [])">
              {{ index > 0 ? ', ' : '' }} {{ city?.city?.name ?? 'почтовые города' }}
            </span>
                <span>(ID:{{ div.id }})</span>
              </div>
              <div v-if="allowToHideDivUsers.includes(div.id)">
                <button @click="hideDivUsers[div.id] = !hideDivUsers[div.id]" class="btn btn-default">
                  {{ hideDivUsers[div.id] ? 'Показать' : 'Скрыть' }}
                </button>
              </div>
            </div>
          </td>
        </tr>
        <template v-if="!hideDivUsers[div.id]">
          <template v-if="(users[div.id]?.chief ?? []).length">
            <tr v-for="(r, index1) in users[div.id].chief">
              <td width="50px">{{ index1 + 1 }}</td>
              <td><strong>{{ r.name }} ({{ r.login }}) ({{ r.id }})</strong></td>
              <td>
                <template
                  v-if="userDetails[r.id] && userDetails[r.id].telegram_chat_data && userDetails[r.id].telegram_chat_data.details.chat_id">
                  <i class="icon-fa icon-fa-paper-plane color_blue"></i>
                </template>
              </td>
              <td>
                <template v-if="userDetails[r.id] && userDetails[r.id].tablet_imei">
                  <button
                    v-if="!popover[r.id].imei"
                    type="button"
                    @click="popover[r.id].imei = true"
                    class="btn btn-xs btn-outline-info"
                  >
                    {{ userDetails[r.id].tablet_imei.details }}
                  </button>

                  <v-popover
                    popoverClass="popover_white"
                    :auto-hide="true"
                    @hide="destroyPopover(r.id, 'imei')"
                    :open="popover[r.id] && popover[r.id].imei"
                    v-if="popover[r.id].imei"
                  >
                    <button type="button" class="btn btn-xs btn-outline-info">
                      {{ userDetails[r.id].tablet_imei.details }}
                    </button>
                    <template slot="popover">
                      <div>
                        <p class="mb-1">Редактирование устройства</p>
                        <div>
                          <LoadingButton
                            title="Отвязать IMEI"
                            className="btn btn-warning btn-xs mb-1"
                            :onClick="() => updateUser(r.id, 'imei', 'disable_imei')"
                            :loading="btnLoading"
                            color="white"
                          />

                          <LoadingButton
                            title="Отозвать сертификат"
                            className="btn btn-warning btn-xs"
                            :onClick="() => updateUser(r.id, 'imei', 'disable_tablet_certificate')"
                            :loading="btnLoading"
                            color="white"
                          />
                        </div>
                      </div>
                    </template>
                  </v-popover>

                </template>
              </td>
              <td>
                <div v-html="userInfoMessage(r.id)"/>
              </td>
              <td class="text-right">
                <div class="flex justify-content-end">
                  <button
                    v-if="popover[r.id] && !popover[r.id].disable && (!r.orders || !r.orders.length)"
                    type="button"
                    @click="popover[r.id].disable = true"
                    class="btn btn-xs btn-outline-warning mr-1"
                  >
                    В архив
                  </button>

                  <v-popover
                    popoverClass="popover_white"
                    :auto-hide="true"
                    @hide="destroyPopover(r.id, 'disable')"
                    :open="popover[r.id] && popover[r.id].disable"
                    v-if="popover[r.id] && popover[r.id].disable"
                  >
                    <button type="button" class="btn btn-xs btn-outline-warning mr-1">
                      В архив
                    </button>
                    <template slot="popover">
                      <div>
                        <p class="mb-1">Отправить курьера</p>
                        <p class="mb-1"><strong>{{ r.name }}</strong></p>
                        <p class="mb-1">в архив?</p>
                        <div>
                          <LoadingButton
                            title="в архив"
                            className="btn btn-warning btn-xs"
                            :onClick="() => updateUser(r.id, 'disable')"
                            :loading="btnLoading"
                            color="white"
                          />
                        </div>
                      </div>
                    </template>
                  </v-popover>
                </div>
              </td>
              <td>
                <button
                  v-if="editUser"
                  @click="editUser(r)"
                  class="btn btn-xs btn-info pull-right"
                >
                  <i class="icon-fa icon-fa-eye"></i>
                </button>
              </td>
            </tr>
          </template>
          <template v-if="(users[div.id]?.runners ?? []).length">
            <tr v-for="(r, index2) in users[div.id].runners">
              <td width="50px">{{ ((users[div.id]?.chief ?? []).length ?? 0) + 1 + index2 }}</td>
              <td>{{ r.name }} ({{ r.login }}) ({{ r.id }})</td>
              <td>
                <template
                  v-if="userDetails[r.id] && userDetails[r.id].telegram_chat_data && userDetails[r.id].telegram_chat_data.details.chat_id">
                  <i class="icon-fa icon-fa-paper-plane color_blue"></i>
                </template>
              </td>
              <td>
                <template v-if="userDetails[r.id] && userDetails[r.id].tablet_imei">

                  <button
                    v-if="!popover[r.id].imei"
                    type="button"
                    @click="popover[r.id].imei = true"
                    class="btn btn-xs btn-outline-info"
                  >
                    {{ userDetails[r.id].tablet_imei.details }}
                  </button>

                  <v-popover
                    popoverClass="popover_white"
                    :auto-hide="true"
                    @hide="destroyPopover(r.id, 'imei')"
                    :open="popover[r.id] && popover[r.id].imei"
                    v-if="popover[r.id].imei"
                  >
                    <button type="button" class="btn btn-xs btn-outline-info">
                      {{ userDetails[r.id].tablet_imei.details }}
                    </button>
                    <template slot="popover">
                      <div>
                        <p class="mb-1">Редактирование устройства</p>
                        <div>
                          <LoadingButton
                            title="Отвязать IMEI"
                            className="btn btn-warning btn-xs mb-1"
                            :onClick="() => updateUser(r.id, 'imei', 'disable_imei')"
                            :loading="btnLoading"
                            color="white"
                          />

                          <LoadingButton
                            title="Отозвать сертификат"
                            className="btn btn-warning btn-xs"
                            :onClick="() => updateUser(r.id, 'imei', 'disable_tablet_certificate')"
                            :loading="btnLoading"
                            color="white"
                          />
                        </div>
                      </div>
                    </template>
                  </v-popover>

                </template>
              </td>
              <td>
                <div v-html="userInfoMessage(r.id)"/>
              </td>
              <td class="text-right">
                <div class="flex justify-content-end">
                  <button
                    v-if="popover[r.id] && !popover[r.id].disable && (!r.orders || !r.orders.length)"
                    type="button"
                    @click="popover[r.id].disable = true"
                    class="btn btn-xs btn-outline-warning mr-1"
                  >
                    В архив
                  </button>

                  <v-popover
                    popoverClass="popover_white"
                    :auto-hide="true"
                    @hide="destroyPopover(r.id, 'disable')"
                    :open="popover[r.id] && popover[r.id].disable"
                    v-if="popover[r.id] && popover[r.id].disable"
                  >
                    <button type="button" class="btn btn-xs btn-outline-warning mr-1">
                      В архив
                    </button>
                    <template slot="popover">
                      <div>
                        <p class="mb-1">Отправить курьера</p>
                        <p class="mb-1"><strong>{{ r.name }}</strong></p>
                        <p class="mb-1">в архив?</p>
                        <div>
                          <LoadingButton
                            title="в архив"
                            className="btn btn-warning btn-xs"
                            :onClick="() => updateUser(r.id, 'disable')"
                            :loading="btnLoading"
                            color="white"
                          />
                        </div>
                      </div>
                    </template>
                  </v-popover>
                </div>
              </td>
              <td>
                <button
                  v-if="editUser"
                  @click="editUser(r)"
                  class="btn btn-xs btn-info pull-right"
                >
                  <i class="icon-fa icon-fa-eye"></i>
                </button>
              </td>
            </tr>
          </template>
        </template>
      </template>
      </tbody>
    </table>

    <hr>
    <h5>Курьеры без дивизиона и не активные</h5>

    <table class="table table-hover table-sm">
      <tbody>
      <template v-if="unlinkedUsers && unlinkedUsers.length">
        <tr class="division_info">
          <td colspan="10">Курьеры без дивизиона</td>
        </tr>
        <tr v-for="(r, index) in unlinkedUsers">
          <td width="50px">{{ index + 1 }}</td>
          <td>{{ r.name }} ({{ r.login }})</td>
          <td class="text-right">
            <button
              v-if="editUser"
              @click="editUser(r)"
              class="btn btn-xs btn-info pull-right"
            >
              <i class="icon-fa icon-fa-eye"></i>
            </button>
          </td>
        </tr>
      </template>
      <template v-if="inactiveUsers && inactiveUsers.length">
        <tr class="division_info">
          <td colspan="10">
            <div class="flex justify-content-between">
              <div>Курьеры в архиве</div>
              <div>
                <button @click="hideDivUsers.archive = !hideDivUsers.archive" class="btn btn-default">
                  {{ hideDivUsers.archive ? 'Показать' : 'Скрыть' }}
                </button>
              </div>
            </div>
          </td>
        </tr>
        <template v-if="!hideDivUsers.archive">
          <tr v-for="(r, index) in inactiveUsers">
            <td width="50px">{{ index + 1 }}</td>
            <td>{{r.id}}: {{ r.name }} ({{ r.login }})</td>
            <td class="text-right">
              <button
                v-if="editUser"
                @click="editUser(r)"
                class="btn btn-xs btn-info pull-right"
              >
                <i class="icon-fa icon-fa-eye"></i>
              </button>
            </td>
          </tr>
        </template>
      </template>
      </tbody>
    </table>

  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton"
import api from "@/api";

export default {
  props: ['users', 'editUser', 'inactiveUsers', 'unlinkedUsers'],
  components: {
    LoadingButton,
  },
  data() {
    return {
      btnLoading: false,
      popover: {},
      userDetails: {},
      allowToHideDivUsers: [1],
      hideDivUsers: {
        1: true,
        archive: true,
      },
    }
  },
  computed: {
    $AllDivisions() {
      return this.$store.getters["platform/divisions"];
    }
  },
  mounted() {
    this.sortData();
  },
  methods: {
    getSortedDivision() {
      return _.sortBy(Object.values(this.$AllDivisions).filter((d) => d.is_active), 'title');
    },
    sortData() {
      let userDetails = {};
      let popover = {};
      Object.keys(this.users).forEach((div) => {
        // this.showRunners[div] = false;
        // if (!data.users[div].runners) return;
        ([...(this.users[div].runners || []), ...(this.users[div].chief || [])]).forEach((u) => {
          userDetails[u.id] = {};
          popover[u.id] = {
            disable: false,
            imei: false,
          };
          u.details.forEach((d) => {
            userDetails[u.id][d.alias] = d;
          })
        });
      })
      this.popover = popover;
      this.userDetails = userDetails;
    },
    destroyPopover(id, type) {
      this.popover[id][type] = false;
    },
    async updateUser(id, action, subAction = null) {
      this.btnLoading = true;
      console.log(action);
      const {data} = await api.post('users/edit/' + id, {
        user: {id: id},
        action,
        subAction
      })
      if (data.success) {
        toastr['success']('Обновлено');
        this.destroyPopover(id, action);
        switch (action) {
          case 'disable':
            let division;
            let index;
            Object.keys(this.users).forEach((div) => {
              if (!this.users[div].runners) return;
              if (index && index !== -1) return;
              index = this.users[div].runners.findIndex((u) => u.id === id);
              if (index && index !== -1) {
                division = div;
              }
            })
            let allRunners = [...this.users[division].runners];
            let runner = this.users[division].runners[index];
            delete allRunners[index];
            allRunners = allRunners.filter((r) => r);
            this.users[division].runners = allRunners;
            this.inactiveUsers.push(runner);
            break;
        }
      } else {
        toastr['warning'](data.message || 'Ошибка сервера');
      }
      this.btnLoading = false;
    },
    userInfoMessage(id) {
      let html = '';
      if (!this.userDetails[id] || !this.userDetails[id].images) {
        html += '<p class="color_dark_red mb-0">Нет сканов документов!</p>';
      }
      return html;
    },
  }
}
</script>

<style scoped>
i.color_blue {
  color: #5BBFDE;
}

.division_info {
  background-color: #caf2ff;
}
</style>
